import { render, staticRenderFns } from "./EditAna.vue?vue&type=template&id=1965f5fb"
import script from "./EditAna.vue?vue&type=script&lang=js"
export * from "./EditAna.vue?vue&type=script&lang=js"
import style0 from "./EditAna.vue?vue&type=style&index=0&id=1965f5fb&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports